export const AddTspState = {
  SelectCountry: 0,
  RegistrationType: 1,
  Form: 2,
};
